export function SectionHeader({ title, description }: { icon?: React.ComponentType; title: string; description: string }) {
  return (
    <div className="mb-4">
      <h3 className="text-xl font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground mt-1">{description}</p>
    </div>
  );
}
